'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Slider: {
        displayName: 'Slider'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Slider/Slider.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Slider = _wrapComponent('Slider')(function (_Component) {
    (0, _inherits3.default)(Slider, _Component);

    function Slider(props) {
        (0, _classCallCheck3.default)(this, Slider);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call(this, props));

        _this.goToSlide = _this.goToSlide.bind(_this);

        if (!(typeof _this.goToSlide === 'function')) {
            throw new TypeError('Value of "this.goToSlide" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.goToSlide));
        }

        _this.handleDragStart = _this.handleDragStart.bind(_this);

        if (!(typeof _this.handleDragStart === 'function')) {
            throw new TypeError('Value of "this.handleDragStart" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.handleDragStart));
        }

        _this.handleDragMove = _this.handleDragMove.bind(_this);

        if (!(typeof _this.handleDragMove === 'function')) {
            throw new TypeError('Value of "this.handleDragMove" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.handleDragMove));
        }

        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        if (!(typeof _this.handleDragEnd === 'function')) {
            throw new TypeError('Value of "this.handleDragEnd" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleDragEnd));
        }

        return _this;
    }

    /*getDefaultProps() {
        return {
            loop: false,
            selected: 0,
            showArrows: true,
            showNav: true,
        };
    }
     getInitialState() {
        return {
            dragStart: 0,
            dragStartTime: new Date(),
            index: 0,
            lastIndex: 0,
            transition: false,
        };
    }*/

    (0, _createClass3.default)(Slider, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var selected = this.props.selected;


            this.setState({
                index: selected,
                lastIndex: selected
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var selected = this.props.selected;


            if (selected !== nextProps.selected) {
                this.goToSlide(nextProps.selected);
            }
        }
    }, {
        key: 'getDragX',
        value: function getDragX(event, isTouch) {
            return isTouch ? event.touches[0].pageX : event.pageX;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event, isTouch) {
            var x = this.getDragX(event, isTouch);

            this.setState({
                dragStart: x,
                dragStartTime: new Date(),
                transition: false,
                slideWidth: _server2.default.findDOMNode(this.refs.slider).offsetWidth
            });
        }
    }, {
        key: 'handleDragMove',
        value: function handleDragMove(event, isTouch) {
            var _state = this.state,
                dragStart = _state.dragStart,
                lastIndex = _state.lastIndex,
                slideWidth = _state.slideWidth;


            var x = this.getDragX(event, isTouch);
            var offset = dragStart - x;
            var percentageOffset = offset / slideWidth;
            var newIndex = lastIndex + percentageOffset;
            var SCROLL_OFFSET_TO_STOP_SCROLL = 30;

            // Stop scrolling if you slide more than 30 pixels
            if (Math.abs(offset) > SCROLL_OFFSET_TO_STOP_SCROLL) {
                event.stopPropagation();
                event.preventDefault();
            }

            this.setState({
                index: newIndex
            });
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            var children = this.props.children;
            var _state2 = this.state,
                dragStartTime = _state2.dragStartTime,
                index = _state2.index,
                lastIndex = _state2.lastIndex;


            var timeElapsed = new Date().getTime() - dragStartTime.getTime();
            var offset = lastIndex - index;
            var velocity = Math.round(offset / timeElapsed * 10000);

            var newIndex = Math.round(index);

            if (Math.abs(velocity) > 5) {
                newIndex = velocity < 0 ? lastIndex + 1 : lastIndex - 1;
            }

            if (newIndex < 0) {
                newIndex = 0;
            } else if (newIndex >= children.length) {
                newIndex = children.length - 1;
            }

            this.setState({
                dragStart: 0,
                index: newIndex,
                lastIndex: newIndex,
                transition: true
            });
        }
    }, {
        key: 'goToSlide',
        value: function goToSlide(index, event) {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                loop = _props.loop;


            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (index < 0) {
                index = loop ? children.length - 1 : 0;
            } else if (index >= children.length) {
                index = loop ? 0 : children.length - 1;
            }

            this.setState({
                index: index,
                lastIndex: index,
                transition: true
            }, function () {
                if (_this2.props.onSlide) {
                    _this2.props.onSlide({
                        index: _this2.state.index,
                        lastIndex: _this2.state.lastIndex,
                        element: _this2.props.children[_this2.state.index]
                    });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var View = _helpers.ThemeHelper.getViewForComponent('Slider');

            return _react3.default.createElement(
                View,
                {
                    handleDragStart: this.handleDragStart,
                    handleDragMove: this.handleDragMove,
                    handleDragEnd: this.handleDragEnd,
                    transition: this.state.transition,
                    index: this.state.index,
                    showArrows: this.props.showArrows,
                    showNav: this.props.showNav,
                    loop: this.props.loop,
                    lastIndex: this.state.lastIndex,
                    goToSlide: this.goToSlide
                },
                this.props.children
            );
        }
    }]);
    return Slider;
}(_react2.Component));

exports.default = Slider;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Slider/Slider.jsx
// module id = 1766
// module chunks = 0